import React, { useContext, useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import FoldableTagList from '@wix/da-ds/pkg/TagList/FoldableTagList';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import CollapsibleBlock from '../../../CollapsibleBlock';
import License from '../../../License';
import TextRenderer from '../../../TextRenderer/TextRenderer';
import MatureIndicator from '../../../SubmissionDetails/_partials/MatureIndicator';
import StatBlock from '../_partials/StatBlock';
import Subjects from '../_partials/Subjects';
import DetailItemList from './DetailItemList';
import NftDetails from '../../../Nft/NftDetails';
import defaultStyles from './Default.scss';
var DESCRIPTION_COLLAPSE_HEIGHT = 130;
export var ExtendedDetails = function (_a) {
    var _b;
    var deviation = _a.deviation, _c = _a.deviation, deviationId = _c.deviationId, author = _c.author, publishedTime = _c.publishedTime, isMature = _c.isMature, _d = _c.extended, _e = _d === void 0 ? {} : _d, subjectTags = _e.subjectTags, locationTag = _e.locationTag, tags = _e.tags, license = _e.license, descriptionText = _e.descriptionText, nfts = _e.nfts;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var nft_review_mint = useFlag('nft_review_mint');
    var descriptionRef = useRef(null);
    var _f = useState(), collapsedDescription = _f[0], setCollapsedDescription = _f[1];
    var isSubscribedButBlocked = useSubscriptionTier(deviation).isSubscribedButBlocked;
    var isDescriptionTextShown = !!((_b = descriptionText === null || descriptionText === void 0 ? void 0 : descriptionText.html) === null || _b === void 0 ? void 0 : _b.markup) &&
        !isSubscribedButBlocked;
    var areDetailItemsShown = !isSubscribedButBlocked;
    // On mobile, collapse description block if height is over the threshold
    // deviationId is in deps to make sure we run this again if deviation changes due to duperbrowse
    useEffect(function () {
        var _a, _b;
        if (isMobile &&
            ((_b = (_a = descriptionRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) > DESCRIPTION_COLLAPSE_HEIGHT) {
            setCollapsedDescription(true);
        }
    }, [isMobile, deviationId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StatBlock, { deviation: deviation, className: defaultStyles['badges-and-stats'] }),
        tags && (React.createElement("div", { className: defaultStyles['tags'] },
            React.createElement(FoldableTagList, { tags: tags }))),
        React.createElement(Subjects, { className: defaultStyles['subject'], subjectTags: subjectTags, locationTag: locationTag }),
        isDescriptionTextShown && (React.createElement("div", { className: cn(isMobile && defaultStyles['collapsible-description'], defaultStyles['description-wrapper'], collapsedDescription === true &&
                defaultStyles['collapsed-description'], collapsedDescription === false &&
                defaultStyles['expanded-description']), id: "description" },
            React.createElement(VisuallyHidden, null,
                React.createElement(Heading, null, t('deviation.details.description'))),
            React.createElement(TextRenderer, { className: defaultStyles['description'], textContent: descriptionText, legacyTheme: "extended-details", ref: descriptionRef }),
            isMobile && collapsedDescription && (React.createElement("div", { className: defaultStyles['expand-description'] },
                React.createElement(PlainButtonOrLink, { onClick: function () { return setCollapsedDescription(false); }, biData: BiData({
                        evid: 2,
                        click_info: 'dev_page_description_expand',
                    }), "aria-controls": 'description', "aria-expanded": collapsedDescription ? false : true }, t('deviation.details.showFullDescription')))))),
        areDetailItemsShown && (React.createElement(CollapsibleBlock, { buttonTextCollapsed: t('deviation.details.more'), buttonTextExpanded: t('deviation.details.less'), maxHeight: isMobile ? 120 : 160, buttonClassName: defaultStyles['collapse-button'], className: defaultStyles['collapsible-block'], shutterBlockClassName: defaultStyles['collapsible-content'], fadeClassName: defaultStyles['collapsible-fade'], showFade: true },
            React.createElement("div", null,
                React.createElement(DetailItemList, { deviation: deviation })))),
        isMature && React.createElement(MatureIndicator, null),
        nft_review_mint &&
            nfts &&
            nfts.map(function (nft) { return React.createElement(NftDetails, { key: nft.nftId, nft: nft }); }),
        React.createElement("div", { className: defaultStyles['license'] },
            React.createElement(License, { license: license, author: author, publishedTime: publishedTime }))));
};
ExtendedDetails.displayName = 'ExtendedDetails';
export default ExtendedDetails;
//# sourceMappingURL=ExtendedDetails.js.map